import { ArrowUpRight, Plus } from 'lucide-react';
import './official-partners.css';

const partnersVisible = true;
const partners = [
  {
    name: 'RiP Development',
    heading: ['RiP', 'Development'],
    description: 'High Quality FiveM Scripts Store providing the best scripts for your FiveM server',
    url: 'https://store.development.rip/',
    domain: 'store.development.rip',
    logo: '/partners/rip-development.webp',
    width: 224,
    height: 320,
  },
  {
    name: "Redutzu's Scripts",
    heading: ["Redutzu's", 'Scripts'],
    description: <>Handcrafted resources for <strong>QBCore, QBox, ESX &amp; Standalone</strong>, built for stability, zero lag, and servers that demand the best.</>,
    url: 'https://redutzu.com/',
    domain: 'redutzu.com',
    logo: '/partners/redutzu-scripts.webp',
    width: 320,
    height: 320,
  },
];

export function OfficialPartners() {
  if (!partnersVisible) return null;
  return (
    <section className="official-partners" aria-label="Official partners">
      <div className="official-partners__masthead"><span>Official partners</span></div>
      {partners.map(partner => (
      <div key={partner.domain} className="official-partners__entry">
      <a href={partner.url} target="_blank" rel="noopener noreferrer" className="official-partners__feature">
        <div className="official-partners__signatures" aria-hidden="true">
          <span className="official-partners__signature"><span className="official-partners__bckt" /><small>BCKT</small></span>
          <Plus className="official-partners__join" />
          <span className="official-partners__signature"><span className={`official-partners__mark${partner.width === partner.height ? ' official-partners__mark--square' : ''}`}><img src={partner.logo} alt="" width={partner.width} height={partner.height} loading="lazy" /></span><small>{partner.name}</small></span>
        </div>
        <div className="official-partners__story">
          <h2>{partner.heading[0]}<br />{partner.heading[1]}<span>.</span></h2>
          <p>{partner.description}</p>
          <span className="official-partners__action">Explore {partner.name} <span><ArrowUpRight aria-hidden="true" /></span></span>
        </div>
      </a>
      <div className="official-partners__footnote"><span>{partner.domain}</span></div>
      </div>
      ))}
    </section>
  );
}
